import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    showFormModal: false,
    componentName: null,
  },
  reducers: {
    openFormModal: (state, action) => {
      state.showFormModal = true;
      state.componentName = action.payload;
    },
    closeFormModal: (state) => {
      state.showFormModal = false;
    },
  },
});

export const { openFormModal, closeFormModal } = modalSlice.actions;
export default modalSlice.reducer;
